import axios from "axios";
import env from "environment";

export default async function fetchCLUsForParcel(feature) {
  const response = await axios({
    method: "post",
    url: env.REACT_APP_DTN_CLUS_URL,
    data: {
      feature,
    },
    headers: {
      "Content-Type": "application/json",
    },
  });

  let cluPolyFeatures = [];

  if (response.status === 200) {
    cluPolyFeatures = response.data.data.features || [];
  }

  return cluPolyFeatures;
}
